import React, { FC } from 'react';
import LangButton from './LangButton';
import { Box } from '~Styles';

const langs = [
  { code: 'en', label: 'English' },
  { code: 'se', label: 'Svenska' },
  { code: 'es', label: 'Español' },
  { code: 'no', label: 'Norsk' },
  { code: 'dk', label: 'Dansk' },
  { code: 'tr', label: 'Türkçe' },
];

const LanguageSwitcher: FC = () => {
  return (
    <Box display="flex" flexWrap="wrap" justifyContent="center" gap="small">
      {langs.map((lang) => (
        <LangButton key={lang.code} langKey={lang.code}>
          {lang.label}
        </LangButton>
      ))}
    </Box>
  );
};
export default LanguageSwitcher;
